import posthog from 'posthog-js'
import type { App, Plugin } from 'vue'

// Install and configure Posthog: https://posthog.com/docs/libraries/vue-js#method-2-use-provide--inject
const posthogPlugin: Plugin = {
  install(app: App) {
    if (!import.meta.env.PROD || !import.meta.env.VITE_APP_POSTHOG_TOKEN) {
      return
    }

    posthog.init(import.meta.env.VITE_APP_POSTHOG_TOKEN, {
      api_host: 'https://ph.swipe4work.com',
      person_profiles: 'identified_only',
      capture_pageview: false,
      disable_session_recording: true,
    })
    app.provide('posthog', posthog)
  },
}

export default posthogPlugin
